import styled from 'styled-components'
import Color from '../../constants/color.constants'

export const Button = styled.button`
  display: inline-block;
  font-weight: 400;
  line-height: 1.5;
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  cursor: pointer;
  user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  border-radius: 0.3rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  text-decoration: none;
  outline: 0;
`

export const ButtonPrimaryStyle = styled(Button)`
  &:focus {
    color: ${Color.white};
    border-color: ${Color.primaryHover};
    background-color: ${Color.primaryHover};
  }
  &:hover {
    color: ${Color.white};
    border-color: ${Color.primaryHover};
    background-color: ${Color.primaryHover};
  }
  &:active {
    color: ${Color.white};
    border-color: ${Color.primaryClick};
    background-color: ${Color.primaryClick};
  }
  color: ${Color.white};
  border-color: ${Color.primary};
  background-color: ${Color.primary};
`

export const ButtonPrimaryOutlineStyle = styled(Button)`
  &:focus {
    color: ${Color.white};
    border-color: ${Color.primaryHover};
    background-color: ${Color.primaryHover};
  }
  &:hover {
    color: ${Color.white};
    border-color: ${Color.primaryHover};
    background-color: ${Color.primaryHover};
  }
  &:active {
    color: ${Color.white};
    border-color: ${Color.primaryClick};
    background-color: ${Color.primaryClick};
  }
  color: ${Color.primary};
  border-color: ${Color.primary};
`

export const ButtonPrimaryOutlineNoBackgroundStyle = styled(Button)`
  &:focus {
    color: ${Color.primary};
    border-color: ${Color.primaryHover};
    background-color: ${Color.white};
  }
  &:hover {
    color: ${Color.primary};
    border-color: ${Color.primaryHover};
    background-color: ${Color.white};
  }
  &:active {
    color: ${Color.primaryClick};
    border-color: ${Color.primaryClick};
    background-color: ${Color.white};
  }
  color: ${Color.primary};
  border-color: ${Color.primary};
`

export const ButtonDangerOutlineStyle = styled(Button)`
  &:focus {
    color: ${Color.white};
    border-color: ${Color.dangerHover};
    background-color: ${Color.dangerHover};
    /* outline: 0; */
    /* filter: brightness(130%); */
  }
  &:hover {
    color: ${Color.white};
    border-color: ${Color.dangerHover};
    background-color: ${Color.dangerHover};
  }
  &:active {
    color: ${Color.white};
    border-color: ${Color.dangerClick};
    background-color: ${Color.dangerClick};
  }

  color: ${Color.danger};
  border-color: ${Color.danger};
`

export const ButtonDangerStyle = styled(Button)`
  &:focus {
    color: ${Color.white};
    border-color: ${Color.dangerHover};
    background-color: ${Color.dangerHover};
    /* outline: 0; */
    /* filter: brightness(130%); */
  }
  &:hover {
    color: ${Color.white};
    border-color: ${Color.dangerHover};
    background-color: ${Color.dangerHover};
  }
  &:active {
    color: ${Color.white};
    border-color: ${Color.dangerClick};
    background-color: ${Color.dangerClick};
  }
  color: ${Color.white};
  border-color: ${Color.danger};
  background-color: ${Color.danger};
`

export const ButtonSecondaryOutlineStyle = styled(Button)`
  &:focus {
    color: ${Color.white};
    border-color: ${Color.secondaryHover};
    background-color: ${Color.secondaryHover};
    /* outline: 0; */
    /* filter: brightness(130%); */
  }
  &:hover {
    color: ${Color.white};
    border-color: ${Color.secondaryHover};
    background-color: ${Color.secondaryHover};
  }
  &:active {
    color: ${Color.white};
    border-color: ${Color.secondaryClick};
    background-color: ${Color.secondaryClick};
  }

  color: ${Color.secondary};
  border-color: ${Color.secondary};
`

export const ButtonSecondaryStyle = styled(Button)`
  &:focus {
    color: ${Color.white};
    border-color: ${Color.secondaryHover};
    background-color: ${Color.secondaryHover};
    /* outline: 0; */
    /* filter: brightness(130%); */
  }
  &:hover {
    color: ${Color.white};
    border-color: ${Color.secondaryHover};
    background-color: ${Color.secondaryHover};
  }
  &:active {
    color: ${Color.white};
    border-color: ${Color.secondaryClick};
    background-color: ${Color.secondaryClick};
  }
  color: ${Color.white};
  border-color: ${Color.secondary};
  background-color: ${Color.secondary};
`
